export default __webpack_public_path__ + "static/media/Gloves of the Earth Mother.d0c62a3a.jpg";